import request from '@/utils/request'

//const serverURL = "https://vab-unicloud-3a9da9.service.tcloudbase.com";
//const apiURL = "/notice/getList";

// 获取消息通知列表
export function getNoticeList(params) {
  return request({
    url: '/notification/findRecordList',
    method: 'get',
    params,
  })
}
// 获取未读消息数量
export function getUnReadCount(params) {
  return request({
    url: '/notification/findUnReadRecordCount',
    method: 'get',
    params,
  })
}
// 设置消息已读
export function readRecord(data) {
  return request({
    url: '/notification/readRecord',
    method: 'post',
    data,
  })
}


// 获取短信发送记录
export function getSmsRecordList(params) {
  return request({
    url: '/notification/findSmsRecordList',
    method: 'get',
    params,
  })
}
